import NewReleasesIcon from '@mui/icons-material/NewReleases';
import LightbulbCircleRoundedIcon from '@mui/icons-material/LightbulbCircleRounded';
import ContactlessRoundedIcon from '@mui/icons-material/ContactlessRounded';

// post feed and create post
export const tagsList = [
  {icon: <ContactlessRoundedIcon/>, label:"Discussion", color:"secondary"},
  {icon: <NewReleasesIcon/>, label:"Spoiler", color:"warning"},
  {icon: <LightbulbCircleRoundedIcon/>, label:"Theory", color:"success"}
]